import OfflineDataBase from './OfflineDataBase';
import { isVMayorIgual } from '../helpers/Utils';

class AndroidDataBase extends OfflineDataBase {
  constructor() {
    super();
  }

  async selectTimeWindow(ids, start, end) {
    try {
      let params = JSON.stringify({
        ids,
        start,
        end
      });
      let events = window.AndroidDBInterface.getLocalEpg(params);
      events = JSON.parse(events);
      if (Array.isArray(events) && events.length === 0) {
        for (let i = 0; i < ids.length; i++) {
          events.push([]);
        }
      }
      console.log('[AndroidDataBase] selectTimeWindow events' + JSON.stringify(events));
      return new Promise(resolve => resolve(events));
    } catch (e) {
      return new Promise(resolve => resolve([]));
    }
  }

  async select(id_composite, id, group_id) {
    try {
      let event = null;
      if (isVMayorIgual(527)) {
        event = window.AndroidDBInterface.getEventByCompositeId(id_composite || `${group_id}${id}`);
      }
      else {
        event = window.AndroidDBInterface.getEvent(id);
      }
      event = JSON.parse(event);
      console.log('[AndroidDataBase] selectEvent event' + JSON.stringify(event));
      return new Promise(resolve => resolve(event));
    } catch (e) {
      return new Promise(resolve => resolve(null));
    }
  }

  async updateRecordings(recordings = []) {
    console.log('[AndroidDataBase] updateRecordings');
    try {
      recordings = recordings.map(recording => {
        if (!recording.id_composite) {
          recording.id_composite = `${recording.group_id}${recording.event_alf_id || recording.id}`;
        }
        delete recording.id;
        delete recording.group_id;
        return recording;
      });
      recordings = JSON.stringify(recordings);
      const result = window.AndroidDBInterface.updateRecordings(recordings);
      return new Promise(resolve => resolve(result));
    } catch (e) {
      return new Promise(resolve => resolve(false));
    }
  }
}

export default AndroidDataBase;



// WEBPACK FOOTER //
// ./src/AAFPersistenceManager/offline/AndroidDataBase.js